import { render, staticRenderFns } from "./UserRegisterParams.vue?vue&type=template&id=5b15408b&scoped=true&"
import script from "./UserRegisterParams.vue?vue&type=script&lang=js&"
export * from "./UserRegisterParams.vue?vue&type=script&lang=js&"
import style0 from "./UserRegisterParams.vue?vue&type=style&index=0&id=5b15408b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15408b",
  null
  
)

component.options.__file = "UserRegisterParams.vue"
export default component.exports